module.exports = __webpack_public_path__ + "static/media/TableChipped_After.22db1c8e.jpg";